import { render, staticRenderFns } from "./standard.vue?vue&type=template&id=40c43cdf&scoped=true&"
import script from "./standard.vue?vue&type=script&lang=js&"
export * from "./standard.vue?vue&type=script&lang=js&"
import style0 from "./standard.vue?vue&type=style&index=0&id=40c43cdf&prod&lang=css&"
import style1 from "./standard.vue?vue&type=style&index=1&id=40c43cdf&prod&lang=less&scoped=true&"
import style2 from "./standard.vue?vue&type=style&index=2&id=40c43cdf&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c43cdf",
  null
  
)

export default component.exports